export default {"src":"/pro/_next/static/media/virtual.f1390234.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};